import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.regexp.exec.js";
//
//
//
//

export default {
  name: 'icon',
  props: {
    type: String,
    isMsg: Boolean
  },
  computed: {
    className: function className() {
      // compatible with old type param
      return "weui-icon weui_icon_".concat(this.type, " weui-icon-").concat(this.type.replace(/_/g, '-'));
    }
  }
};